var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.linkClassName,attrs:{"href":_vm.link}},[_c('img',{class:_vm.imageClassName,attrs:{"src":_vm.imageLink,"alt":_vm.content}}),_c('span',{class:_vm.contentClassName},[_vm._v(" "+_vm._s(_vm.content)+" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }